import loadable from '@loadable/component'

export const IconTeaser = loadable(() => import('./IconTeaser'))
export const IconTeasers = loadable(() => import('./IconTeasers'))
export type { IconTeaserProps } from './IconTeaser'
export type { IconTeasersProps } from './IconTeasers'
